/* eslint-disable @typescript-eslint/no-explicit-any */
import Translatable from "@/components/translatable_text/Translatable";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Fragment } from "react";
import { Link } from "react-router-dom";

type Props = {
  list: any;
};

export function Breadcrumbs({ list }: Props) {
  const isActive = (item: any) => location.pathname === item.href

  return (

    <div
      style={{
        backgroundImage: `url(/light/assets/imgs/gcadbanar.jpeg)`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }} 
      className=" mb-6x w-full h-10 rounded-md flex items-center"
    >
      <Breadcrumb>
        <BreadcrumbList>
          {list?.map((item: any, i: number) => (
            <Fragment key={i}>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link style={{ color: `${isActive(item) ? 'gray' : 'black'}`}} to={item.href}><Translatable>{item.title}</Translatable></Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
                {i < list.length - 1 && <BreadcrumbSeparator />}
            </Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
}
